import { Component, Input } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router }  from '@angular/router';
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { HttpService } from '../../shared/services/http.service';
import { CommonService } from '../../shared/services/common.service';
import { LayoutService } from '../../layout/layout.service';

@Component({
    selector: 'my-app-sidenav',
    styles: [],
    template: require('./sidenav.component.html')
})

export class AppSidenavComponent {
    AppConfig;

    constructor(private router: Router,public httpService : HttpService,public errorHandler : ErrorHandler,
                public layoutService : LayoutService, public sessionHandler : SessionHandler, public commonService:CommonService){
    }

    ngOnInit() {
        this.AppConfig = APPCONFIG;
    }

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav.component.ts